export const ROUTE_SHORTCUTS = '/shortcuts'
export const ROUTE_SHORTCUTS_FAMILY = '/shortcuts/folder/:familyId'
export const ROUTE_SHORTCUTS_ADD = '/shortcuts/add'
export const ROUTE_SHORTCUTS_EDIT = '/shortcuts/:shortcutId/edit'
export const ROUTE_TASKS = '/tasks'
export const ROUTE_TASKS_DETAILS = '/tasks/:taskId/details'
export const ROUTE_TASKS_ADD = '/tasks/add'
export const ROUTE_TASKS_EDIT = '/tasks/:taskId/edit'
export const ROUTE_TASKS_COPY = '/tasks/:taskId/copy'
export const ROUTE_TASKS_V2 = '/tasks2'
export const ROUTE_TASKS_V2_DETAILS = '/tasks2/:id/details'
export const ROUTE_TASKS_V2_ADD = '/tasks2/add'
export const ROUTE_TASKS_V2_EDIT = '/tasks2/:taskId/edit'
export const ROUTE_TASKS_V2_COPY = '/tasks2/:taskId/copy'
export const ROUTE_GROUPS = '/groups'
export const ROUTE_GROUP_V2 = '/groups2/:groupId'
export const ROUTE_GROUP_SHORTCUTS = '/shortcuts/groups/:groupId'
export const ROUTE_GROUP_SHORTCUTS_ADD = '/shortcuts/groups/:groupId/add'
export const ROUTE_GROUP_SHORTCUTS_EDIT = '/shortcuts/groups/:groupId/:shortcutId/edit'
export const ROUTE_GROUP_SHORTCUTS_USERS = '/shortcuts/groups/:groupId/users'
export const ROUTE_GROUP_SHORTCUTS_USER = '/shortcuts/groups/:groupId/users/:userId'
export const ROUTE_GROUP_SHORTCUTS_USER_EDIT = '/shortcuts/groups/:groupId/users/:userId/:shortcutId/edit'
export const ROUTE_GROUP_SHORTCUTS_USER_ADD = '/shortcuts/groups/:groupId/users/:userId/add'
export const ROUTE_STUDENT_DETAIL_V2 = '/groups2/:groupId/user/:userId'
export const ROUTE_STUDENT_BROWSER_HISTORY = '/groups2/:groupId/user/:userId/browser-history'
export const ROUTE_STUDENT_BROWSER_HISTORY_BY_DOMAIN =
  '/groups2/:groupId/user/:userId/browser-history/:domainName/detail'
export const ROUTE_SUBSTITUTES = '/substitutes'
export const ROUTE_SUBSTITUTES_ADD = '/substitutes/:groupId/:id/add'
export const ROUTE_SUBSTITUTES_EDIT = '/substitutes/:groupId/:id/edit'
export const ROUTE_HELP = '/help'
export const ROUTE_SESSION_EXPIRED = '/session-expired'
export const ROUTE_PROFILE = '/profile'
export const ROUTE_MANAGEMENT = '/management'
export const ROUTE_MANAGEMENT_TEAMS = '/management/teams'
export const ROUTE_MANAGEMENT_IMAGE_LOGIN = '/management/image-login'
